<template>
  <el-popover placement="bottom-end" width="220" trigger="click" popper-class="theme-switcher-popover">
    <div class="theme-panel">
      <div class="theme-panel-title">主题配色</div>
      <div class="theme-list">
        <button
          v-for="t in themes"
          :key="t.id"
          type="button"
          class="theme-item"
          :class="{ active: currentId === t.id }"
          @click="pick(t.id)"
        >
          <span class="theme-dot" :style="{ background: t.primary }"></span>
          <span class="theme-name">{{ t.name }}</span>
          <i v-if="currentId === t.id" class="el-icon-check theme-check"></i>
        </button>
      </div>
    </div>
    <i slot="reference" class="el-icon-brush header-icon" title="切换主题"></i>
  </el-popover>
</template>

<script>
import { THEMES } from '@/config/theme'
import { applyTheme, getStoredThemeId } from '@/utils/applyTheme'

export default {
  name: 'ThemeSwitcher',
  data() {
    return {
      themes: THEMES,
      currentId: getStoredThemeId()
    }
  },
  methods: {
    pick(id) {
      const theme = applyTheme(id)
      this.currentId = id
      this.$message.success(`已切换为「${theme.name}」`)
    }
  }
}
</script>

<style scoped>
.header-icon {
  font-size: 18px;
  color: #4e5969;
  cursor: pointer;
}
.header-icon:hover {
  color: var(--gas-primary, #1677ff);
}
.theme-panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 10px;
}
.theme-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.theme-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.theme-item:hover {
  border-color: var(--gas-primary, #1677ff);
  background: #f7f8fa;
}
.theme-item.active {
  border-color: var(--gas-primary, #1677ff);
  background: var(--gas-primary-light, #e8f3ff);
}
.theme-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}
.theme-name {
  flex: 1;
  text-align: left;
  font-size: 13px;
  color: #1d2129;
}
.theme-check {
  color: var(--gas-primary, #1677ff);
  font-weight: bold;
}
</style>
